
export default {
  name: "EmploeCard",

  props: {
    emploe: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    altText: function () {
      return [
        this.emploe?.firstname,
        this.emploe?.lastname,
        this.emploe?.position,
      ].filter(Boolean).join(' ').trim()
    }
  }
}
